import { useContext } from 'react'

import { Form as FormProvider } from 'components/Form'
import { DefaultsContext } from 'features/globalSetup/pages/Defaults/DefaultsContext'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { Form } from './Form'
import { useUpdateWorkspacePrebidConfiguration } from './hooks/useUpdateWorkspacePrebidConfiguration'
import { Schema, schema, schemaDefault } from './schema'

export const FormContainer = (): React.JSX.Element => {
  const { formId, loading, prebidStack, setTouched, setValid } = useContext(DefaultsContext)
  const { workspaceId } = useWorkspaceParam()
  const { errors: apiErrors, update } = useUpdateWorkspacePrebidConfiguration()

  if (!prebidStack?.workspaceConfig) {
    throw Error('workspaceConfig should exists at this point')
  }

  return (
    <FormProvider<Schema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault(prebidStack.workspaceConfig, workspaceId)}
    >
      {() => <Form />}
    </FormProvider>
  )
}
